import React from "react";
import { BsArrowRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import Loading from "../../Components/Loading";
import { renderPrice, timeSince } from "../../Utils/functions";
import { useSingle } from "./Hooks";

const Preview = () => {
  const navigate = useNavigate();
  const { form, loading } = useSingle();
  return (
    <div>
      <header className="d-flex justify-content-between">
        <div className="d-flex  align-items-center">
          <button
            className="btn"
            onClick={() => {
              navigate(-1);
            }}
          >
            <BsArrowRight />
          </button>
          <p className="fs-12 m-0">جزییات آگهی</p>
        </div>
      </header>
      {loading.show ? (
        <>
          <div className="container">
            <div className="row">
              <Loading height={"200px"} />
            </div>
            <div className="row">
              <Loading count={3} height={"100px"} />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="single">
                  <div className="image">
                    <img src={form?.main_image?.url} className="content" />
                  </div>
                  <div className="title-single">
                    <p>{form?.title}</p>

                    <div className="context-single">
                      <div className="content-single">
                        <p className="txt">آگهی تاییدشده کارشناسان صنعتبان</p>
                      </div>
                      <p className="text">
                        آگهی موردنظر توسط صنعتبان تایید شده است
                      </p>
                    </div>
                  </div>
                  <div>
                    <div className="box">
                      <div className="key-value-box">
                        <p className="key-box">نام آگهی دهنده:</p>
                        <p className="value-box">{form?.client?.fullname}</p>
                      </div>
                      <div className="key-value-box">
                        <p className="key-box">شهر:</p>

                        <p className="value-box">{form?.city?.title}</p>
                      </div>
                      <div className="key-value-box">
                        <p className="key-box">دسته بندی:</p>

                        <p className="value-box">{form?.category?.title}</p>
                      </div>
                      <div className="key-value-box">
                        <p className="key-box">قیمت:</p>
                        <p className="value-box">{renderPrice(form?.price)}</p>
                      </div>
                      <div className="info-single">
                        <p className="time-single">
                          {timeSince(form?.updated_at)}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="description-single">
                    <p className="title-description-single">توضیحات:</p>
                    <div className="content-single">
                      <p className="text">{form?.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Preview;
